
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_145pa_ut89u_99",
  "focus-lock": "awsui_focus-lock_145pa_ut89u_134",
  "calendar": "awsui_calendar_145pa_ut89u_138",
  "date-picker-container": "awsui_date-picker-container_145pa_ut89u_154",
  "date-picker-trigger": "awsui_date-picker-trigger_145pa_ut89u_159",
  "date-picker-input": "awsui_date-picker-input_145pa_ut89u_163",
  "open-calendar-button": "awsui_open-calendar-button_145pa_ut89u_168"
};
  